import { render, staticRenderFns } from "./ToggleButtonCheck.vue?vue&type=template&id=51152002&"
import script from "./ToggleButtonCheck.vue?vue&type=script&lang=js&"
export * from "./ToggleButtonCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51152002')) {
      api.createRecord('51152002', component.options)
    } else {
      api.reload('51152002', component.options)
    }
    module.hot.accept("./ToggleButtonCheck.vue?vue&type=template&id=51152002&", function () {
      api.rerender('51152002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ToggleButtonCheck.vue"
export default component.exports